import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import ControlsStyles from '@stories/Components/Misc/Carousels/Carousel/Controls/Controls.styles';
import FullWidthCarouselStyles from '@stories/Components/Misc/Carousels/FullWidthCarousel/FullWidthCarousel.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper, { BackgroundVariant, } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
const Outer = styled.div `
  scroll-margin: var(--headerHeight, 0px) 0 0;
  overflow: hidden;

  &[data-variant=${BackgroundVariant.Blue}] {
    ${FullWidthCarouselStyles.Container} {
      --bgColour: ${brand.primary.blue.dark};
      --fgColour: ${brand.global.white};
    }

    ${ControlsStyles.Button} {
      box-shadow: none;
    }
  }

  &[data-variant=${BackgroundVariant.White}] {
    ${FullWidthCarouselStyles.Container} {
      --bgColour: transparent;
      --fgColour: ${brand.primary.blue.dark};
    }
  }

  &[data-variant=${BackgroundVariant.AccountBlue}] {
    ${FullWidthCarouselStyles.Container} {
      --bgColour: ${rgba(brand.primary.blue.light, 0.2)};
      --fgColour: ${brand.global.black};
    }
  }

  ${FullWidthCarouselStyles.CarouselWrapper} {
    @media ${from(Device.Desktop)} {
      overflow: hidden;
    }
  }

  &[data-visible-columns='two'] {
    ${FullWidthCarouselStyles.CarouselWrapper} {
      @media ${from(Device.TabletLarge)} {
        --visibleItems: 2;
      }

      @media ${from(Device.Desktop)} {
        --visibleItems: 2;
      }
    }
  }

  &[data-visible-columns='three'] {
    ${FullWidthCarouselStyles.CarouselWrapper} {
      @media ${from(Device.TabletLarge)} {
        --visibleItems: 3;
      }

      @media ${from(Device.Desktop)} {
        --visibleItems: 3;
      }
    }
  }

  &[data-visible-columns='four'] {
    ${FullWidthCarouselStyles.CarouselWrapper} {
      @media ${from(Device.TabletLarge)} {
        --visibleItems: 3;
      }

      @media ${from(Device.Desktop)} {
        --visibleItems: 4;
      }
    }
  }
`;
const Container = styled(SectionWrapper) `
  overflow: hidden;

  [data-variant=${BackgroundVariant.Blue}] & {
    --sectionBackground: ${brand.primary.blue.dark};
    --sectionColour: ${brand.global.white};
  }

  background-color: var(--sectionBackground);
  color: var(--sectionColour);

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(16, 58)};
  }
`;
const Grid = styled.div `
  display: grid;
  gap: ${fluid(24, 32)};
  grid-template-columns: 1fr;

  @media ${from(Device.TabletSmall)} {
    grid-template-columns: 1fr 1fr;
  }

  [data-visible-columns='two'] & {
    @media ${from(Device.TabletLarge)} {
      grid-template-columns: 1fr 1fr;
    }
  }

  [data-visible-columns='three'] & {
    @media ${from(Device.TabletLarge)} {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  [data-visible-columns='four'] & {
    @media ${from(Device.TabletLarge)} {
      grid-template-columns: repeat(3, 1fr);
    }

    @media ${from(Device.Desktop)} {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;
const CtaCardsStyles = {
    Container,
    Grid,
    Outer,
};
export default CtaCardsStyles;
